import { lazy, Suspense } from 'react';
import { useAppDispatch } from 'app/hooks';
import If from 'components/If';
import Spin from 'components/Spin';

import { setIsFinishAccountSetupModalClosed } from 'services/ctp/ctpSlice';

const FinishAccountSetupModal = lazy(
  () => import('pages/finish-account-setup'),
);

type Props = {
  isOpen: boolean;
  handleNextModalSequence: () => void;
};

function FinishAccountSetup({ handleNextModalSequence, isOpen }: Props) {
  const dispatch = useAppDispatch();

  const handleModalClose = () => {
    dispatch(setIsFinishAccountSetupModalClosed(true));
    handleNextModalSequence();
  };

  return (
    <If condition={isOpen}>
      <Suspense fallback={<Spin fullscreen />}>
        <FinishAccountSetupModal isOpen handleClose={handleModalClose} />
      </Suspense>
    </If>
  );
}

export default FinishAccountSetup;
